import { v4 as uuidv4 } from 'uuid';

export default class {
    constructor() {
        this.registry = {};
        this.instances = {};
    }

    init() {
        this.initialiseObserver();
    }

    initialiseObserver() {
        if (window.MutationObserver) {
            this.observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => this.processMutation(mutation));
            });

            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }

    scan(node = document.body) {
        Object.keys(this.registry).forEach(componentName => {
            const componentNodes = node.querySelectorAll(`[data-daisy-component="${componentName}"]`);

            componentNodes.forEach(componentNode => this.createInstanceByNode(componentNode));
        });
    }

    processMutation(mutation) {
        if (mutation.removedNodes.length) {
            mutation.removedNodes.forEach(node => this.processRemovedNode(node));
        }

        if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => this.processAddedNode(node));
        }
    }

    processAddedNode(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }

        const event = new CustomEvent('nodeAdded', {
            bubbles: true,
            detail: {
                node
            }
        });

        window.dispatchEvent(event);

        if (node.hasAttribute('data-daisy-component')) {
            this.createInstanceByNode(node);
        }

        this.scan(node);
    }

    processRemovedNode(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }

        if (node.hasAttribute('data-daisy-component')) {
            this.deleteInstanceByNode(node);
        }

        const componentNodes = node.querySelectorAll('[data-daisy-component]');

        componentNodes.forEach(componentNode => this.deleteInstanceByNode(componentNode));
    }

    getInstanceByNode(node) {
        let instance = null;

        if (node && node.hasAttribute('data-daisy-component')) {
            const id = node.getAttribute('data-daisy-component-id');

            if (id && this.instances[id]) {
                instance = this.instances[id];
            }
        }

        return instance;
    }

    createInstanceByNode(node) {
        const componentName = node.getAttribute('data-daisy-component');
        const id = uuidv4();
        const component = this.registry[componentName];

        if (!component || node.hasAttribute('data-daisy-component-id')) {
            return;
        }

        let instance;

        if (component.module) {
            instance = component.module(node);
        } else {
            const Class = component.constructor;

            instance = new Class(node);
        }

        node.jsApi = instance;
        node.setAttribute('data-daisy-component-id', id);

        this.instances[id] = {
            component: componentName,
            node,
            jsApi: instance
        };
    }

    deleteInstanceByNode(node) {
        const id = node.getAttribute('data-daisy-component-id');
        const instance = this.getInstanceById[id];

        if (instance) {
            delete this.instances[id];
        }
    }

    getInstanceById(id) {
        return this.instances[id];
    }

    register(componentArray) {
        componentArray.forEach(({ name, module, constructor }) => {
            this.registry[name] = { module, constructor };
        });
    }
}
